import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import registerServiceWorker from "./utils/registerServiceWorker";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import rootReducer from "./reducers/rootReducer";
import { userLoggedIn } from "./actions/user";
import HomePage from "./components/pages/homePage/homePage";
import CreateBookmarkPage from "./components/pages/createBookmarkPage/createBookmarkPage";
import UpdateBookmarkPage from "./components/pages/updateBookmarkPage/updateBookmarkPage";
import LoginPage from "./components/pages/loginPage/loginPage";
import BookmarkPage from "./components/pages/bookmarkPage/bookmarkPage";
import ConfirmationPage from "./components/pages/confirmationPage/confirmationPage";
import Error404Page from "./components/pages/error404Page/error404Page";
import UserRoute from "./components/routes/userRoute";
import GuestRoute from "./components/routes/guestRoute";
import "normalize.css";

const store = createStore(
	rootReducer,
	composeWithDevTools(applyMiddleware(thunk))
);

// If user is logged in
if (localStorage.wikiJWT) {
	const user = { token: localStorage.wikiJWT };
	store.dispatch(userLoggedIn(user));
}

const Root = () => {
	return (
		<BrowserRouter>
			<Provider store={store}>
				<Switch>
					<UserRoute path="/" exact component={HomePage} />
					<UserRoute path="/search" exact component={HomePage} />
					<UserRoute
						path="/bookmark/create"
						exact
						component={CreateBookmarkPage}
					/>
					<UserRoute
						path="/bookmark/update/:uuid"
						exact
						component={UpdateBookmarkPage}
					/>
					<UserRoute path="/bookmark/:uuid" exact component={BookmarkPage} />
					<GuestRoute path="/login" exact component={LoginPage} />
					<Route
						path="/confirmation/:token"
						exact
						component={ConfirmationPage}
					/>
					<Route component={Error404Page} />
				</Switch>
			</Provider>
		</BrowserRouter>
	);
};

ReactDOM.render(<Root />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js